import React, { useEffect, useState } from "react";
import Pagination from "../../Components/Pagination/Pagination";

import { useRef } from "react";
import "../Transactions/loaderstyle.css";
import LocalLoader from "../../Components/Loader/LocalLoader";
import { CSVLink } from "react-csv";
import jsPDF from "jspdf";
import "jspdf-autotable";

import {
  checkTransactionStatus,
  getTransactionList,
  getVendorTransctionList,
  searchUser,
} from "../../utils/api";
import { FilterWrapper } from "../../assets/styles/FilterStyle";
import DatePicker from "react-datepicker";
import {
  getDateFromDateObj,
  inputNumber,
  isEmpty,
  isNumber,
  pdfData,
} from "../../utils/common";
import { TableWrapper } from "../../Components/styledConstant";
import { useLocation, useNavigate } from "react-router-dom";
import raiseTicket from "../../assets/images/raise_ticket.svg";
import AsideLeft from "../../Components/AsideLeft/AsideLeft";
import { useSelector } from "react-redux";
import { AlertWrapper } from "../../Components/Modal/style";
import DateRangePicker from "../../Components/DateRangePicker/DateRangePicker";
require("react-datepicker/dist/react-datepicker.css");

const csvHeader = [
  { label: "User Id", key: "userId" },
  { label: "Transaction Id", key: "txnId" },
  { label: "Date", key: "createdDate" },
  { label: "Order Id", key: "orderId" },
  { label: "Subscribed Service", key: "subscribedService" },
  { label: "Subscribed Sub Service", key: "subscribedSubService" },
  { label: "Amount", key: "txnAmount" },
  { label: "Fee", key: "fee" },
  { label: "Fee Type", key: "feeType" },
  { label: "GST", key: "gst" },
  { label: "Final Amount", key: "finalAmount" },
  { label: "Opening Balance", key: "openingBalance" },
  { label: "Closing Balance", key: "closingBalance" },
  { label: "Status", key: "status" },
];

const statusList = [
  {
    label:"Success",
  value:"SUCCESS"
},
  {
    label:"Refund",
  value:"REFUND"
},
  {
    label:"Fail",
  value:"FAIL"
},
  {
    label:"Initiated",
  value:"INITIATED"
},
  {
    label:"Pending",
  value:"PENDING"
},
]
const subscribedService = [
  {
    label:"UPI pay",
  value:"UPI_PAY"
},
  {
    label:"Fund Transfer",
  value:"FUND_TRANSFER"
},
  {
    label:"Recharge",
  value:"RECHARGE"
},
]

const VendorTransaction = () => {
  const [transactions, setTransactions] = useState([]);
  const [totalPages, setTotalPages] = useState(null);
  const [currPage, setCurrPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [fromDate, setStartDate] = useState("");
  const [toDate, setEndDate] = useState("");
  const [totalElements,setTotalElements] = useState(10);


  const [loading, setLoading] = useState(false);
  const [pdfData_, setPdfData] = useState([]);
  const [serviceType, setServiceType] = useState("");
  const [selectStatus, setSelectStatus] = useState("");
  const [texId, setTexId] = useState("");

  const link = useRef();
  const [downloadLoader, setDownloadLoader] = useState("");
  const [showfilter, setShowFilter] = useState("");
  const [checkStatusMsg, setCheckStatusMsg] = useState({});

  const navigate = useNavigate();

  const { user } = useSelector((state) => state.user);

    const clearRef = useRef(null);
  const clearDate = (callback) => {
    if (clearRef.current) return;
    clearRef.current = callback;
  };

  const constChangeDate = (startDate, endDate) => {
    if (endDate) {
      setEndDate(endDate);
      setStartDate(startDate);
    }
  };

  const onClearDate = () => {
    setEndDate("");
    setStartDate("");
  };


  // Date Format
  var currentDate = new Date();
  var formattedDate = [
    currentDate.getDate(),
    currentDate.getMonth() + 1,
    currentDate.getFullYear(),
  ]
    .map((n) => (n < 10 ? `0${n}` : `${n}`))
    .join("-");


  const transactionData = (parm = {}) => {
    const {key,page,status,serviceT} = {...parm};
  
    let _fromdate = getDateFromDateObj(fromDate, "YYYY-MM-DD");
    let _todate = getDateFromDateObj(toDate, "YYYY-MM-DD");

    if (
      getDateFromDateObj(fromDate, "YYYY-MM-DD") === "Invalid date" ||
      getDateFromDateObj(toDate, "YYYY-MM-DD") === "Invalid date"
    ) {
      _fromdate = "";
      _todate = "";
    }
   
    let payload = {
      status:status?status === "none"?"":status:selectStatus,
      toDate:_todate,
      fromDate:_fromdate,
      txnId:texId,
      serviceType:serviceT?serviceT === "none"?"":serviceT:serviceType,
      pagination: {
        pageNo: currPage,
        pageSize: pageSize,
      },
    };
   
    if (key === "CSV" || key === "PDF") {
  
      payload = {
        
        pagination: {
          pageSize: totalElements,
        },
      };
      if (key === "CSV") {
        setDownloadLoader("CSV")
      } else {
        setDownloadLoader("PDF")
      }
     
    }else{
      setLoading(true);
    }

    if(key ==="pagination"){
      payload.pagination.pageNo = page;
      setCurrPage(page);
    }else{
      payload.pagination.pageNo = 0;
      setCurrPage(0);
    }
    if(key == "refresh"){
      payload = {
        status:"",
        toDate:"",
        fromDate:"",
        txnId:"",
        serviceType:"",
        pagination: {
          pageNo: 0,
          pageSize: pageSize,
        },
      };
    }
    getVendorTransctionList(payload).then((resp) => {
      setLoading(false);
    
      setDownloadLoader("");
      if (resp?.data?.message === "SUCCESS") {
    
        if(key !== "CSV" && key !== "PDF"){

          setTransactions(resp?.data?.data?.content);
          setTotalPages(resp?.data?.data?.totalPages);
          setTotalElements(resp?.data?.data?.totalElements);
      
      }else{
      
        setPdfData(resp?.data?.data?.content);
        
        if(key==="CSV"){
          
          setTimeout(() => {
            const csvlink = link.current;
					csvlink.link.click();
        
          }, 1);
        } else if(key==="PDF"){
          setDownloadLoader("")
         
          setTimeout(() => {
            pdfDownload(resp?.data?.data?.content);
       
          }, 1);
         
        }

					
      }
      }
    });
  
 
  };

  const location = useLocation();
 

  useEffect(() => {

      transactionData();
   
  }, []);

  const currentPage = (page) =>{
 
     transactionData({key:"pagination",page:page});
  }
  const changStatus = (value="") =>{
    if(value === "none"){
setSelectStatus("");
    }else{
setSelectStatus(value);
    }
     
     transactionData({status:value});
  }
  const changServiceType = (value="") =>{

    if(value === "none"){
setServiceType("");
    }else{
setServiceType(value);
    }
     transactionData({serviceT:value});
  }


  const navigationDaital = (item) => {
    navigate(`/vendor-transaction/${item?.txnId}`, {
      state: { detail: item, type: "Vendor Transaction" },
    });
  };


  useEffect(() => {
    setTimeout(() => {
      setCheckStatusMsg({});
    }, 5000);
  }, []);



  const pdfDownload = (data) => {
  
    const tableHeader = [
      {
        userId: "User Id",
        txnId: "Transaction Id",
        createdDate: "Date",
        orderId: "Order Id",
        subscribedService: "Subscribed Service",
        subscribedSubService: "Subscribed Sub Service",
        txnAmount: "Amount",
        fee: "Fee",
        feeType:"Fee Type",
        gst:"GST",
        finalAmount:"Final Amount",
        openingBalance: "Opening Amount",
        closingBalance: "Closing Amount",
        status: "Status",
      },
    ];

		pdfData(data, tableHeader, 'Vendor-Transaction-History',550);
	};


  const refresh = () =>{
  
    transactionData({key:"refresh"});
    setEndDate("");
    setStartDate("");
    setServiceType("");
    setTexId("")
    setSelectStatus("");
      if (clearRef.current) {
      clearRef.current();
    }
  }

  return (
    <div className="transactions_container">
      <div style={{ padding: "30px" }}>
        <div
          className="transaction_main_container"
          style={{ marginTop: "-10px" }}
        >
          <div className="userlist_head">
            <div className="userlist_heading">
              <div className="userlist_left">
                <label>Vendor Transactions</label>
              </div>
              <div className="userlist_right">
             
                {downloadLoader !== "PDF" ? (
                  <button
                    className="pdf"
                    onClick={() => transactionData({key:"PDF"})}
                  >
                    PDF
                  </button>
                ) : (
                  <button className="pdf">
                    <div className="btn-loader">
                      <i className="fa-solid fa-spinner"></i>
                    </div>
                  </button>
                )}

                {downloadLoader !== "CSV" ? (
                  <button
                    className="xls"
                    onClick={() => transactionData({key:"CSV"})}
                  >
                    CSV
                  </button>
                ) : (
                  <button className="xls">
                    <div className="btn-loader">
                      <i className="fa-solid fa-spinner"></i>
                    </div>
                  </button>
                )}
                <CSVLink
                  ref={link}
                  data={pdfData_}
                  headers={csvHeader}
                  filename="TransactionList.csv"
                ></CSVLink>
              </div>
              <div className="userlist_filter">
                <button
                  className="filter fs-16"
                  onClick={(e) =>
                    showfilter === "active"
                      ? setShowFilter("")
                      : setShowFilter("active")
                  }
                >
                  <i className="fa-solid fa-filter"></i>
                </button>
              </div>
            </div>
          </div>

          <FilterWrapper
            style={{ height: "auto" }}
            className={`display_data ${showfilter}`}
          >
            <div className="filterBox">
              <div className="grow-1">
                <div className="flex align-items gap-15">
                  <div className="input-field">
                    <select
                      className="input_select_field"
                      value={selectStatus}
                      onChange={(e) => changStatus(e.target.value)}
                    >
                      <option value={"none"}>Select Status</option>
                      {statusList.map((item) =>
                      <option value={item.value}>{item.label}</option>
                      )}
                    
                    </select>
                  </div>
                  <div className="input-field">
                    <select
                      className="input_select_field"
                      value={serviceType}
                      onChange={(e) => changServiceType(e.target.value)}
                    >
                      <option value={"none"}> Select Subscribed Service</option>
                      {subscribedService.map((item) =>
                      <option value={item.value}>{item.label}</option>
                      )}
                    
                    </select>
                  </div>

                  <div className="input-field">
                    
                      <input type="text" placeholder="Transaction ID" 
                      value={texId}
                      onChange={(e) =>setTexId(e.target.value)}
                      />
                  
                  </div>

                  {/* <div className="input-field">
                    <div className="flex">
                      <DatePicker
                        showIcon
                        className="date-picker2 date_type"
                        placeholderText="From Date"
                        selected={fromDate}
                        selectsStart
                        valueDefault={null}
                        startDate={fromDate}
                        endDate={toDate}
                        yearDropdownItemNumber={100}
                        scrollableYearDropdown={true}
                        showYearDropdown
                        onKeyDown={(e) => e.preventDefault()}
                        onChange={(date) => setStartDate(date)}
                        maxDate={new Date()}
                      />
                    </div>
                  </div>
                  <div className="input-field">
                    <div className="flex">
                      <DatePicker
                        showIcon
                        className="date-picker2 date_type"
                        placeholderText="To Date"
                        selected={toDate}
                        selectsEnd
                        startDate={fromDate}
                        endDate={toDate}
                        minDate={fromDate}
                        yearDropdownItemNumber={100}
                        scrollableYearDropdown={true}
                        showYearDropdown
                        onKeyDown={(e) => e.preventDefault()}
                        onChange={(date) => setEndDate(date)}
                        maxDate={new Date()}
                      />
                    </div>
                  </div> */}

                      <DateRangePicker
                    applyDate={constChangeDate}
                    defaultDate={null}
                    onClear={onClearDate}
                    clearDate={clearDate}
                  />

                 <div className=" button">
                    <button
                      className="userlist_btn"
                      onClick={() => transactionData("search")}
                      style={{ width: "100px" }}
                    >
                      Search
                    </button>
                  </div>
                  <div className="button">
                    <button
                      className="refresh-btn"
                      style={{ width: "60px" }}
                      onClick={refresh}
                    >
                      <i className="fa fa-refresh"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </FilterWrapper>
        </div>

        {transactions && (
          <div className="table-loader">
               {loading && <LocalLoader className="tableLoader" />}
            <TableWrapper className="table-card-wrapper">
           
              <table className="table">
                <thead>
                  <tr>
                    {/* <td>Sr. No.</td> */}

                    <th>Transaction ID</th>
                    <th>Date</th>
                    <th>Order Id</th>
                    <th>Subscribed Service</th>
                    <th>Subscribed Sub Service</th>
                    
                    <th>Amount</th>
                    <th>Fee</th>
                  <th>Fee Type</th>
                  <th>GST</th>
                  <th>Final Amount </th>
                    <th>Opening Balance</th>
                    <th>Closing Balance</th>
                    <th>Status</th>
                    <th>View Invoice</th>
                  </tr>
                </thead>
                <tbody>
                  {!isEmpty(transactions) &&
                    transactions.map((item, index) => {
                      const inputDate = new Date(item?.createdDate);

                      const formattedDate = inputDate.toLocaleString("en-GB", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                        hour: "numeric",
                        minute: "numeric",
                        hour12: false,
                      });

                      let color = "";
                      if (item?.status?.toUpperCase() === "SUCCESS") {
                        color = "#4CAF50";
                      } else if (item?.status?.toUpperCase() === "REFUND") {
                        color = "#9C27B0";
                      } else if (item?.status?.toUpperCase() === "PENDING") {
                        color = "#FF9800";
                      }
                      else if (item?.status?.toUpperCase() === "INITIATED") {
                        color = "#2196F3";
                      }
                      
                      else {
                        color = "#F44336";
                      }

                      return (
                        <tr key={index}>
                          {/* <td>
                            <span className="card-th">Sr. No.</span>
                            <span className="card-td">
                              {paginastion.currentPage * paginastion.pageSize +
                                index +
                                1}
                            </span>
                          </td> */}
                          {/* <td>{item?.userId}</td> */}
                          <td>
                            <span className="card-th">Transaction ID</span>
                            <span className="card-td">{item?.txnId}</span>
                          </td>
                          <td>
                            <span className="card-th">Date</span>
                            <span className="card-td">{formattedDate}</span>
                          </td>
                          <td>
                            <span className="card-th">Order Id</span>
                            <span
                              className="link card-td"
                              onClick={() => navigationDaital(item)}
                            >
                              {item?.orderId}
                            </span>
                          </td>
                          <td>
                            <span className="card-th">Subscribed Service</span>
                            <span className="card-td">
                              {item?.subscribedService}
                            </span>
                          </td>
                          <td>
                            <span className="card-th">
                              Subscribed Sub Service
                            </span>
                            <span className="card-td">
                              {item?.subscribedSubService || "-"}
                            </span>
                          </td>
                         
                          <td>
                            <span className="card-th">Amount</span>
                            <span className="card-td">{item?.txnAmount}</span>
                          </td>
                          <td>
                          <span className="card-th">Fee</span>
                          <span className="card-td">{item?.fee === null?"-":item?.fee}</span>
                        </td>
                        <td>
                          <span className="card-th">Fee Type</span>
                          <span className="card-td">
                            {item?.feeType === null?"-":item?.feeType}
                          </span>
                        </td>
                        <td>
                          <span className="card-th">GST</span>
                          <span className="card-td">{item?.gst === null ?"-":item?.gst}</span>
                        </td>
                        <td>
                          <span className="card-th">Final Amount</span>
                          <span className="card-td">
                            {item?.finalAmount === null?"-":item?.finalAmount}
                          </span>
                        </td>
                     
                          
                          <td>
                            <span className="card-th">Opening Balance</span>
                            <span className="card-td">
                              {item?.openingBalance}
                            </span>
                          </td>
                          <td>
                            <span className="card-th">Closing Balance</span>
                            <span className="card-td">
                              {item?.closingBalance}
                            </span>
                          </td>
                          <td>
                            <span className="card-th">Status</span>
                            <span className={"card-td "} style={{color:color,fontWeight:"700"}}>
                              {item?.status}
                            </span>
                          </td>
                          <td className="user_action_btn button">
                          <span className="card-th">View Invoice</span>
                          <span><button     onClick={() => navigationDaital(item)}>
                            <i className="fa-regular fa-eye fs-16 update" aria-hidden="true"></i>
                            </button>
                            </span>
                        </td>
                        </tr>
                      );
                    })}

                  {isEmpty(transactions) && !loading && (
                    <tr style={{ textAlign: "center", }}>
                      <td colspan="100%" style={{ textAlign: "center", color: "red" }}>
                        No Transaction Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </TableWrapper>
          </div>
        )}

        {!isEmpty(checkStatusMsg) && (
          <AlertWrapper className={`${checkStatusMsg.type} globle`}>
            <span className="close" onClick={() => setCheckStatusMsg({})}>
              ×
            </span>
            {checkStatusMsg.msg}
          </AlertWrapper>
        )}

        {totalPages > 1 && (
          <Pagination
            items={transactions}
            itemsPerPage={pageSize}
            setitemsPerPage={setPageSize}
            currentPage={currPage}
            setcurrentPage={currentPage}
            totalPages={totalPages}
            forcePage={currPage}
          />
        )}
      </div>
    </div>
  );
};

export default VendorTransaction;
